import type { NavItemId } from './navigationManifest';

/** Descripciones cortas para filas del hub «Más» (mobile). */
export const NAV_ITEM_DESCRIPTIONS: Partial<Record<NavItemId, string>> = {
  salesList: 'Las ventas de este local.',
  cash: 'Abrí el turno, arqueo y salidas de plata.',
  expenses: 'Facturas de proveedores y cuentas a pagar.',
  purchases: 'Órdenes de compra y recepción de mercadería.',
  pricingHub: 'Promos, listas de precios y puntos.',
  promotions: 'Descuentos y promos de este local.',
  diningTables: 'Las mesas del salón y si están ocupadas.',
  diningReservations: 'Reservas del salón: día, hora y comensales.',
  kitchenQueue: 'Comandas pendientes, en preparación y listas.',
  menuOptionGroups: 'Tamaño, extras y lo que el cliente elige.',
  productCombos: 'Armá combos que descuentan el stock de cada componente.',
  appointments: 'Agenda de turnos y reservas.',
  workOrders: 'Trabajos y reparaciones en curso.',
  commissions: 'Comisiones del equipo: panel, planes y alquileres.',
  myCommissions: 'Tus comisiones por ventas.',
  commissionPlans: 'Cómo se calcula cada comisión.',
  boothRentals: 'Cabinas alquiladas y sus pagos.',
  priceLists: 'Precios especiales por lista.',
  loyalty: 'Puntos y premios para clientes.',
  aiAssistant: 'Preguntale al asistente de Vuelto.',
  quotes: 'Cotizaciones y planes de sesiones.',
  fiado: 'Clientes, deudas y cobros.',
  catalog: 'Productos, precios y códigos.',
  inventory: 'Stock, ajustes y conteos.',
  reports: 'Resumen del período.',
  ordersInbox: 'Todo lo que llega por internet.',
  storefrontHub: 'Perfil, horarios, delivery y reseñas.',
  deliverySettings: 'Zonas, envío y pedido mínimo.',
  storeReviews: 'Reseñas y tus respuestas.',
  branchIdentity: 'Nombre y pin en el mapa.',
  branchPosOps: 'Venta sin stock, topes y PIN del POS.',
  branchDevices: 'Impresora, balanza y lector de esta compu.',
  integrationsHub: 'Mercado Pago y facturas.',
  support: 'Consultas al equipo Vuelto.',
  profile: 'Tu usuario, legal y sesión.',
  team: 'Personas, invitaciones y permisos.',
  organization: 'Nombre y cómo operás.',
  billing: 'Plan, cobro y comprobantes.',
  settingsHub: 'Tu negocio y este local.',
  branchSettings: 'Ajustes de este local.',
};

/** Description override when capabilities reshape the hub copy. */
export function resolveNavItemDescription(
  id: NavItemId,
  caps?: Set<import('../session/domain/businessProfile').BusinessCapability>,
): string | undefined {
  if (id === 'catalog' && caps?.has('service_catalog')) {
    return 'Servicios, productos y precios.';
  }
  if (id === 'ordersInbox' && caps?.has('appointments') && !caps?.has('delivery_fulfillment')) {
    return 'Turnos, consultas y mensajes del día.';
  }
  return NAV_ITEM_DESCRIPTIONS[id];
}
